<footer class="app-footer">
  <span>
    <!-- <a href="https://buildyourcareerwi.org/">ABC</a> -->ABC
    Apprenticeship & Training Trust
    <!--&trade;--></span>
  <span class="ml-auto footer_links">
    <a href="assets/application.pdf" target="_blank">
      Learn More    
    </a>
    <app-bugreporting></app-bugreporting>
  </span>
</footer>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-footer/app-footer.component.html